<section class="numericFieldWithSubfields" #subfieldsElement>
  <section class="numericFieldWithSubfieldsTotal">
    <pp-custom-fields-numeric-with-subfields-total
      [ppValue]="ppPointField.value"
      [ppFieldId]="ppFieldId"
      [ppWorkspaceId]="ppWorkspaceId"
      [ppUnit]="unit"
      [ppUnitTooltip]="unitSymbolTooltip"
      [ppIsLocked]="ppIsLocked"
      />

    @if (ppIsLocked) {
      <pp-padlock-icon />
    }

    <pp-custom-field-numeric-with-subfields-expand-collapse
      [ppDisabled]="subfields.length === 0"
      [ppCollapsed]="collapsed"
      [ppNumberOfFields]="subfields.length"
      (ppToggle)="toggleCollapse()"
      />
  </section>

  @for (subfield of subfields; track subfieldTrackByName(index, subfield); let index = $index) {
    @if (!collapsed || subfield.ppNew) {
      <pp-custom-field-numeric-with-subfields-subfield
        [ppUnit]="unit"
        [ppSubfield]="subfield"
        [ppCanEdit]="ppCanEdit"
        (ppUpdate)="updateField($event, index)"
        (ppDelete)="deleteSubfield(index)"
        [ppDecimalPlaces]="+customField.decimalPlaces"
        [ppUnitTooltip]="unitSymbolTooltip"
        [ppIsLocked]="ppIsLocked"
        />
    }
  }

  @if (ppCanEdit && !ppIsLocked) {
    <pp-custom-fields-numeric-with-subfields-add-subfield-button
      [ppDisabled]="addSubfieldButtonDisabled"
      (ppAction)="addSubfield()"
      [ppType]="customField.type"
      />
  }
</section>
